module.exports = __webpack_public_path__ + "static/media/Front-Desk.10fac9a7.png";